module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.page.popShow),
      expression: "!page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tree.current),
      expression: "tree.current"
    }],
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add news")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "page-left-wrap"
  }, [_c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v("news type")])]), _vm._v(" "), _c('el-tree', {
    attrs: {
      "data": _vm.tree.data,
      "props": _vm.tree.prop,
      "expand-on-click-node": false,
      "highlight-current": true,
      "default-expand-all": true
    },
    on: {
      "node-click": _vm.clickModuleTree
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "page-right-wrap"
  }, [(_vm.tree.current) ? _c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v(_vm._s(_vm.tree.current.NtName))])]) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "NiName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "NiSort",
      "label": "Sort",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "NiRead",
      "label": "Read Volume",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('copy-btn', {
          attrs: {
            "text": '/Cms/NewsDetails/' + scope.row.NiCode + '?pathId=20170907c5c74e49'
          }
        }, [_vm._v("copy link")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page.popShow),
      expression: "page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.page.popShow = false
      }
    }
  }, [_vm._v("Close")])], 1)]), _vm._v(" "), _c('NewsForm', {
    ref: "popForm",
    attrs: {
      "sideCurrent": _vm.tree.current
    },
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("News NewsManagement")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("news detail")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-bdc28e00","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/cms/NewsManage.vue
// module id = 793
// module chunks = 1